export const ROLE_SUPER_ADMIN = 'Super Admin'
export const ROLE_ADMIN = 'Admin'
export const ROLE_MEMBER = 'Member'
export const ROLE_DATA_REQUEST_CONTRIBUTOR = 'Data Request Contributor'
